export var EXCLUSION_REASONS = [
    {
        value: "DUPLICATE",
        labelId: "ui-br-legaldeposits.enforcement.exclude.duplicate",
    },
    {
        value: "NOT_SUBJECT_TO_PV",
        labelId: "ui-br-legaldeposits.enforcement.exclude.notSubjectToPv",
    },
    {
        value: "IMPRACTICAL_ENFORCEMENT",
        labelId: "ui-br-legaldeposits.enforcement.exclude.impractical",
    },
    {
        value: "REGIONAL_PV",
        labelId: "ui-br-legaldeposits.enforcement.exclude.regionalPv",
    },
    {
        value: "OTHER",
        labelId: "ui-br-legaldeposits.enforcement.exclude.other",
    },
];
export var EXTRA_COPY_REASONS = [
    {
        value: "REPRINT",
        labelId: "ui-br-legaldeposits.enforcement.extraCopy.reprint",
    },
    {
        value: "BOX_SET",
        labelId: "ui-br-legaldeposits.enforcement.extraCopy.boxSet",
    },
    {
        value: "OTHER",
        labelId: "ui-br-legaldeposits.enforcement.extraCopy.other",
    },
];
/** Two issues of one title share a titleId, so the label is what tells the rows apart. */
export var urgenceTitleKey = function (title) { var _a; return "".concat(title.titleId, "|").concat((_a = title.issueLabel) !== null && _a !== void 0 ? _a : ""); };
export var STATUS_LABEL_IDS = {
    CREATED: "ui-br-legaldeposits.enforcement.status.created",
    OVERDUE: "ui-br-legaldeposits.enforcement.status.overdue",
    RECEIVED: "ui-br-legaldeposits.enforcement.status.received",
    RECEIVED_AFTER_ENFORCEMENT: "ui-br-legaldeposits.enforcement.status.receivedAfterEnforcement",
    EXCLUDED: "ui-br-legaldeposits.enforcement.status.excluded",
    DAMAGED: "ui-br-legaldeposits.enforcement.status.damaged",
    DAMAGED_REPORTED: "ui-br-legaldeposits.enforcement.status.damagedReported",
    REQUESTED: "ui-br-legaldeposits.enforcement.status.requested",
};
export var CHANNEL_LABEL_IDS = {
    EMAIL: "ui-br-legaldeposits.enforcement.channel.email",
    PHONE: "ui-br-legaldeposits.enforcement.channel.phone",
    POSTAL: "ui-br-legaldeposits.enforcement.channel.postal",
    DATA_BOX: "ui-br-legaldeposits.enforcement.channel.dataBox",
    NOTE: "ui-br-legaldeposits.enforcement.channel.note",
};
export var UrgenceSkipReasonEnum;
(function (UrgenceSkipReasonEnum) {
    UrgenceSkipReasonEnum["REMINDER_ALREADY_SENT"] = "REMINDER_ALREADY_SENT";
    UrgenceSkipReasonEnum["ACTIVE_ENFORCEMENT_EXISTS"] = "ACTIVE_ENFORCEMENT_EXISTS";
})(UrgenceSkipReasonEnum || (UrgenceSkipReasonEnum = {}));
